function isDesktop() {
  return window.matchMedia('(min-width: 320.99px)').matches;
}

const defaultHeaderHeight = 80;

(($, Drupal) => {
  function sticky(stickyMenu, stickyPosition, headerHeight) {
    if (window.pageYOffset >= stickyPosition - headerHeight) {
      stickyMenu.style.top = `${headerHeight}px`;
      stickyMenu.classList.add('sticky');
    } else {
      stickyMenu.style.top = 'initial';
      stickyMenu.classList.remove('sticky');
    }
  }

  function initStickyMenu() {
    const header = document.querySelector('.site-header');
    let headerHeight = header ? header.clientHeight : 0;

    const stickyMenu = document.querySelector('.js-sticky-menu');
    let stickyPosition = stickyMenu.offsetTop;

    if (!stickyMenu) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentBoxSize) {
          const contentBoxSize = entry.contentBoxSize[0];

          if (headerHeight === contentBoxSize.blockSize) {
            return;
          }

          headerHeight = contentBoxSize.blockSize;
          stickyPosition = stickyMenu.offsetTop;

          if (
            headerHeight === defaultHeaderHeight &&
            window.pageYOffset >= stickyPosition - headerHeight
          ) {
            stickyMenu.style.top = `${headerHeight}px`;
            stickyMenu.classList.add('sticky');
          }
        }
      });
    });

    resizeObserver.observe(header);

    stickyPosition = stickyMenu.offsetTop;

    window.onscroll = () => {
      if (isDesktop()) {
        sticky(stickyMenu, stickyPosition, headerHeight);
      }
    };

    window.onresize = () => {
      if (isDesktop()) {
        sticky(stickyMenu, stickyPosition, headerHeight);
      } else {
        stickyMenu.style.top = 'initial';
        stickyMenu.classList.remove('sticky');
      }
    };
  }

  Drupal.behaviors.mstStickyMenu = {
    attach: (context) => {
      $('.sticky-menu', context).each(() => initStickyMenu());
      const stickyMenuLinks = document.querySelectorAll('.sticky-menu__list__item a');
      const header = document.querySelector('.site-header');

      if (window.scrollY < window.innerHeight * 0.75) {
        stickyMenuLinks[0].classList.add('current');
      }

      stickyMenuLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const scrollPos = $(link.getAttribute('href')).offset().top;

          const headerHeight = header ? header.clientHeight : 0;

          $('html, body').animate(
            {
              scrollTop: scrollPos - headerHeight - 40,
            },
            500,
          );
        });
      });

      window.addEventListener('scroll', () => {
        const vh = window.outerHeight;
        const horizon = vh * 0.25;

        stickyMenuLinks.forEach((link, index) => {
          const section = document.querySelector(link.getAttribute('href'));
          const coordinateY = section.offsetTop - window.scrollY;

          if (coordinateY < horizon && coordinateY + section.offsetHeight >= horizon) {
            link.classList.add('current');
          } else {
            if (window.scrollY < vh * 0.75 && index === 0) {
              return;
            }
            link.classList.remove('current');
          }
        });
      });
    },
  };
})(jQuery, Drupal);
